import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function TrendingGrid() {
  const hotArticles = getHotArticles(6);
  const mainCard = hotArticles[0];
  const sideCards = hotArticles.slice(1, 3);

  if (!mainCard) return null;

  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8" aria-label="热门爆料">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 md:gap-8 mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-500 leading-tight">
            热门
            <br />
            爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed md:pt-2">
            精选全网关注度最高的吃瓜内容，从网红出轨到明星塌房，每一条爆料都经过严格筛选，确保你看到的都是最劲爆的内容。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {/* Main dark card */}
          <Link
            to={`/article/${mainCard.id}`}
            className="group relative rounded-xl overflow-hidden bg-primary-500 p-5 md:p-6 flex flex-col justify-between min-h-[380px] md:min-h-[420px]"
          >
            <div className="relative z-10">
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center" />
                最热
              </span>
              <h3 className="mt-4 font-heading text-xl md:text-2xl text-background-50 leading-snug group-hover:text-accent-300 transition-colors">
                {mainCard.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/80 line-clamp-3">
                {mainCard.summary}
              </p>
            </div>
            <img
              src={mainCard.image}
              alt={mainCard.title}
              className="absolute inset-0 w-full h-full object-cover object-center opacity-40 group-hover:opacity-50 transition-opacity"
            />
            <div className="relative z-10 flex items-center gap-3 text-xs text-background-200">
              <span>{mainCard.date}</span>
              <span>·</span>
              <span>{mainCard.views.toLocaleString()} 阅读</span>
            </div>
          </Link>

          {/* Side cards */}
          {sideCards.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors flex flex-col"
            >
              <div className="relative h-44 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                {article.isNew && (
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    <i className="ri-flashlight-line w-3 h-3 flex items-center justify-center" />
                    最新
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg text-foreground-800 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2">
                  {article.summary}
                </p>
                <div className="mt-auto pt-3 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}